import Typography from '@mui/material/Typography';
import {string} from 'prop-types';
import React from 'react';

// only use with stable lists
function indexKey(i) {
  return 'key-' + i;
}

function PublicationAbstract({abstract}) {
  return abstract.split('\n\n').map((part, i) => (
    <Typography
      key={indexKey(i)}
      variant="body1"
      component="p"
      sx={{marginBottom: 2}}
    >
      {part}
    </Typography>
  ));
}

PublicationAbstract.propTypes = {
  abstract: string.isRequired,
};

export default PublicationAbstract;
